<template>
  <the-header></the-header>
  <section class="transport">
    <draft-selection></draft-selection>
    <country-selection></country-selection>
    <goods-section></goods-section>
    <submit-draft-section></submit-draft-section>
  </section>
  <the-footer></the-footer>
</template>


<script>
import TheHeader from "../components/common/TheHeader.vue";
import TheFooter from "../components/common/TheFooter.vue";
import DraftSelection from "../components/buy-transport/DraftSelection.vue";
import CountrySelection from "../components/buy-transport/CounrtySelection.vue";
import GoodsSection from "../components/buy-transport/GoodsSection.vue";
import SubmitDraftSection from "../components/buy-transport/SubmitDraftSection.vue";

export default {
  components: {
    TheHeader,
    TheFooter,
    DraftSelection,
    CountrySelection,
    GoodsSection,
    SubmitDraftSection,
  },
};
</script>

<style scoped>
.transport {
  background-color: #f5f5f5;
  padding: 1rem 0 7rem 0;
}
</style>